export default "__VITE_ASSET__2b946286__"